<div class="container">
  <div class="row">
    <div class="col-12">
      <h2 class="text-center">
        How much material will you be shredding?
      </h2>
      <div id="howMuchQuestion">
        <h5 class="text-center">
          <a href="javascript:void(0)" (click)="open()">
            Not sure how much? Click here to use our calculator
          </a>
        </h5>
      </div>
      <div id="howMuchCalculator" style="display: none">
        <form>
          <div class="form-group row d-flex align-items-center">
            <label for="how_much" class="col-12 col-form-label" style="font-size:1.5em;color:#c00;margin:0px 100px 0px 0;">
              How Many Boxes Do You Have?
            </label>
            <label for="how_much" class="col-12 col-form-label" style="margin:0px 100px 0px 0;border-color:">
              Use this handy calculator to convert other volumes into numbers of boxes
              if you are unsure.
            </label>
            <div class="col-12" style="margin:0px 100px 0px 0;border-color:">
              <input
                     type="number" class="form-control-plaintext" [(ngModel)]="qty" #n_input="ngModel"
                     name="qty" style="width: 30%; display: inline; border: 1px solid black;" placeholder="Quantity" />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <div class="select-wrap" style="display:inline;">
                <select class="form-control" [(ngModel)]="type" #t_select="ngModel" name="type" style="display: inline; width: 60%;">
                  <!-- <option value="" selected="selected">[ select volume type ]</option> -->
                  <optgroup label="Bags">
                    <option value="13">Black Plastic Yard/Leaf Bag</option>
                    <option value="14">Tall White Kitchen Bag</option>
                  </optgroup>
                  <!--<optgroup label="Storage Units">
                      <option value="1">5' x 10 ' (50 sq. ft.) - a small walk-in closet</option>
                      <option value="2">10' x 10' (100 sq. ft.) - a large walk-in closet or 1/2 of a small car garage</option>
                      <option value="3">10' x 20' (200 sq. ft.) - a garage for a compact car</option>-->
                  <optgroup label="Filing Cabinets">
                    <option value="11">
                      Vertical Filing Cabinet- 24" drawers - per drawer
                    </option>
                    <option value="12">
                      Lateral Filing Cabinet- 30" drawers - per drawer
                    </option>
                  </optgroup>
                  <optgroup label="File Boxes">
                    <option value="17">Letter/Legal (15" x 12" x 10")</option>
                    <option value="18">Large Letter (24" x 12" x10")</option>
                    <option value="19">Large Legal (24" x 15" x 10")</option>
                  </optgroup>
                  <optgroup label="Bin(s)">
                    <option value="7">64 Gallon Bin</option>
                    <option value="8">95 Gallon Bin</option>
                  </optgroup>
                  <optgroup label="Pallet(s)">
                    <option value="4">
                      Stacked 4 Rows High (4 feet high) - low height
                    </option>
                    <option value="5">
                      Stacked 5 Rows High (5 feet high) - normal height
                    </option>
                    <option value="6">
                      Stacked 6 Rows High (6 feet hiigh) - maximum height - usually
                      shrink-wrapped
                    </option>
                  </optgroup>
                </select>
              </div>
            </div>
            <label for="how_much"
                   class="col-12 col-form-label"
                   style="font-size: 13px;margin:0px 0px;">
              *Disclaimer: The conversion tool is for estimates only. Your shredding
              provider will determine final cost for services.
            </label>
            <div class="col-12" style="display:flex">
              <button type="submit"
                      class="form-control-plaintext"
                      (click)="calculate()"
                      style="border: 1px solid black;">
                Calculate
              </button>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <button type="submit"
                      class="form-control-plaintext"
                      (click)="close()"
                      style="border: 1px solid black;">
                Close
              </button>
            </div>
          </div>
        </form>
        <p class="how-much-notice text-center w-100" *ngIf="pounds > 0">
          {{ ibox + " boxes " + "( " + pounds + " pounds )" }}
        </p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 d-flex">
      <a [routerLink]="getRoute()" class="btn btn-block mt-2 py-5" (click)="onClick('Less than 1 box')">
        <svg height="100px" width="100px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path class="st0" d="M0,179.714v248.969c0,13.568,11.101,24.669,24.669,24.669h50.632V155.107H24.669 C11.101,155.107,0,166.146,0,179.714z" fill="#555555"></path> <path class="st0" d="M487.393,155.107h-50.632v298.245h50.632c13.506,0,24.607-11.101,24.607-24.669V179.714 C512,166.146,500.899,155.107,487.393,155.107z" fill="#555555"></path> <path class="st0" d="M357.765,81.621c0-12.668-10.305-22.973-22.97-22.973h-157.57c-12.672,0-22.976,10.305-22.976,22.973v73.486 h-30.101v298.245h263.709V155.107h-30.09V81.621z M197.418,101.818h117.177v53.289H197.418V101.818z" fill="#555555"></path> </g> </g></svg>
        <p>Less than 1 box</p>
      </a>

      <a [routerLink]='getRoute()' class="btn btn-block mt-2 py-5" (click)="onClick('1 to 3 boxes')">
        <svg id="_001-cup"
             data-name="001-cup"
             xmlns="http://www.w3.org/2000/svg"
             width="100px"
             height="100px"
             viewBox="0 0 512 512">
          <g id="SVGRepo_bgCarrier" stroke-width="0" />

          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

          <g id="SVGRepo_iconCarrier"> <g> <g> <path  fill="#555555" d="M26.256,144.41v236.308h39.385c36.194,0,65.641,29.447,65.641,65.641v39.385h249.436v-39.385 c0-36.195,29.447-65.641,65.641-65.641h39.385V144.41H26.256z M354.462,315.077H157.538V196.923h196.923V315.077z" /> </g> </g> <g> <g> <rect fill="#555555" y="26.256" width="512" height="78.769" /> </g> </g> <g> <g> <rect fill="#555555" x="196.923" y="236.308" width="118.154" height="39.385" /> </g> </g> <g> <g> <path fill="#555555" d="M65.641,420.103H26.256v65.641h65.641v-39.385C91.897,431.881,80.119,420.103,65.641,420.103z" /> </g> </g> <g> <g> <path fill="#555555" d="M446.359,420.103c-14.478,0-26.256,11.779-26.256,26.256v39.385h65.641v-65.641H446.359z" /> </g> </g> </g>
        </svg>
        <p>1 to 3 boxes</p>
      </a>

      <a [routerLink]="['/config', 'how-often']" class="btn btn-block py-5" (click)="onClick('4 to 14 boxes')">
        <svg id="_001-cup"
             data-name="001-cup"
             xmlns="http://www.w3.org/2000/svg"
             width="100px"
             height="100px"
             viewBox="0 0 512 512">

          <g id="SVGRepo_iconCarrier"> <g> <g> <path fill="#555555" d="M469.333,64V42.667C469.333,19.136,450.197,0,426.667,0H85.333C61.803,0,42.667,19.136,42.667,42.667V64 c0,23.531,19.136,42.667,42.667,42.667v128c-23.531,0-42.667,19.136-42.667,42.667v21.333c0,23.531,19.136,42.667,42.667,42.667 v128C85.333,492.864,104.469,512,128,512h256c23.531,0,42.667-19.136,42.667-42.667v-128c23.531,0,42.667-19.136,42.667-42.667 v-21.333c0-23.531-19.136-42.667-42.667-42.667v-128C450.197,106.667,469.333,87.531,469.333,64z M277.333,405.333h-42.667 c-11.797,0-21.333-9.557-21.333-21.333s9.536-21.333,21.333-21.333h42.667c11.797,0,21.333,9.557,21.333,21.333 S289.131,405.333,277.333,405.333z M426.688,298.667h-21.355H106.667H85.333v-21.333h21.333h298.667h21.333L426.688,298.667z M213.333,149.333c0-11.776,9.536-21.333,21.333-21.333h42.667c11.797,0,21.333,9.557,21.333,21.333s-9.536,21.333-21.333,21.333 h-42.667C222.869,170.667,213.333,161.109,213.333,149.333z M405.333,64H106.667H85.333V42.667h341.333L426.688,64H405.333z" /> </g> </g> </g>

        </svg>
        <p>4 to 10 boxes</p>
      </a>
      <a [routerLink]="['/config', 'how-often']" class="btn btn-block py-5" (click)="onClick('15 or more boxes')">
        <svg id="_001-cup"
             data-name="001-cup"
             xmlns="http://www.w3.org/2000/svg"
             width="100px"
             height="100px"
             viewBox="0 0 612.001 612.001">

          <g id="SVGRepo_bgCarrier" stroke-width="0" />

          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

          <g id="SVGRepo_iconCarrier"> <g> <path fill="#555555" d="M599.724,169.892L318.584,55.057c-9.642-3.938-20.449-3.908-30.068,0.085L12.173,169.853 C4.803,172.913,0,180.107,0,188.087v41.11c0,10.904,8.839,19.742,19.742,19.742h14.807c2.726,0,4.936,2.209,4.936,4.936v261.582 c0,24.532,19.887,44.42,44.42,44.42h12.901V322.535h418.39v237.341h12.901c24.532,0,44.42-19.887,44.42-44.42V253.875 c0-2.726,2.21-4.936,4.936-4.936h14.807c10.904,0,19.742-8.839,19.742-19.742v-41.029C612,180.148,607.147,172.925,599.724,169.892 z M197.42,248.939h-98.71v-44.42h98.709L197.42,248.939L197.42,248.939z M355.354,248.939h-98.709v-44.42h98.709V248.939z M513.291,248.939H414.58v-44.42h98.71L513.291,248.939L513.291,248.939z M223.099,461.201h-28.093v38.756h-13.124v-38.756h-28.266 c-10.216,0-18.497,8.281-18.497,18.497v61.68c0,10.216,8.282,18.496,18.497,18.496h69.482c10.216,0,18.497-8.28,18.497-18.496 v-61.68C241.596,469.482,233.314,461.201,223.099,461.201z M340.777,461.201h-28.093v38.756h-13.124v-38.756h-28.265 c-10.216,0-18.497,8.281-18.497,18.497v61.68c0,10.216,8.282,18.496,18.497,18.496h69.481c10.216,0,18.497-8.28,18.497-18.496 v-61.68C359.275,469.482,350.993,461.201,340.777,461.201z M460.642,461.201h-28.093v38.756h-13.124v-38.756H391.16 c-10.216,0-18.497,8.281-18.497,18.497v61.68c0,10.216,8.281,18.496,18.497,18.496h69.481c10.216,0,18.497-8.28,18.497-18.496 v-61.68C479.14,469.482,470.857,461.201,460.642,461.201z M282.182,349.896h-28.093v38.757h-13.124v-38.757H212.7 c-10.216,0-18.497,8.282-18.497,18.497v61.68c0,10.216,8.282,18.497,18.497,18.497h69.482c10.216,0,18.497-8.281,18.497-18.497 v-61.68C300.68,358.178,292.397,349.896,282.182,349.896z M402.732,349.896h-28.094v38.757h-13.123v-38.757H333.25 c-10.216,0-18.497,8.282-18.497,18.497v61.68c0,10.216,8.282,18.497,18.497,18.497h69.482c10.216,0,18.496-8.281,18.496-18.497 v-61.68C421.229,358.178,412.948,349.896,402.732,349.896z" /> </g> </g>

        </svg>
        <p>11 or more boxes</p>
      </a>
    </div>
    <div class="col-12 text-center d-flex goBack" style=" width: 100%;padding: 20px 0;">
      <div class="col-10 text-center col-md-2">
        <app-back class="w-100 text-center"></app-back>
      </div>
    </div>
  </div>

</div>
